import React from "react";

const Loader: React.FC = () => (
  <div className="fixed top-0 left-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-10">
    <div>
      <div className="relative w-24 h-24 rounded-full animate-spin bg-gradient-to-r from-gray-400 via-blue-500 to-yellow-400 ">
        <div className="absolute w-20 h-20 transform -translate-x-1/2 -translate-y-1/2 bg-gray-200 border-2 border-white rounded-full top-1/2 left-1/2"></div>
      </div>
    </div>
  </div>
);

export default Loader;
